import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { CardActionArea } from '@mui/material';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Alert from '@mui/material/Alert';
import colors from "assets/mavric-theme/base/colors";
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import Paper from '@mui/material/Paper';
import typography from "assets/mavric-theme/base/typography";
import Radio from '@mui/material/Radio';
import RadioGroup, { useRadioGroup } from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { Tab, Tabs } from '@mui/material';

const { size } = typography;
const { primary, secondary, text } = colors;

import { getMavricTokenTemplate, postMavricTokenTemplate } from 'apis/CustomersApis';
import { getKeyValue, validateName, validatePortNumber, removeAllSpaces } from 'common_utils/utils';
import { logout } from "actions/auth";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`config-tabpanel-${index}`}
      aaria-labelledby={`config-tab-${index}`}
      {...other}
    >
      {/* <Box m={0} p={0}>{children}</Box> */}
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </Typography>
  );
}

function a11yProps(index) {
  return {
    id: `config-tabpanel-${index}`,
    'aria-controls': `customer-tabpanel-${index}`,
  }
}

export default function MavricTokenView() {
  const dispatch = useDispatch();
  const UserId = useSelector(state => state.userid);
  const Token = useSelector(state => state.accessToken);

  // Mavric API Fields and Message Queue Settings
  const [mavricAPIHost, setMavricAPIHost] = useState("");
  const [mavricAPITimeout, setMavricAPITimeout] = useState(120);
  const [mqHost, setMQHost] = useState("");
  const [mqPort, setMQPort] = useState("");
  const [mqUser, setMQUser] = useState("");
  const [mqPassword, setMQPassword] = useState("");
  const [mqTimeout, setMQTimeout] = useState(60);

  //Mavric Stream Srvr Fields 
  const [streamSrvrHost, setStreamSrvrHost] = useState("");
  const [streamSrvrPort, setStreamSrvrPort] = useState("");
  const [signalingServer, setSignalingServer] = useState("");
  const [streamSrvrToken, setStreamSrvrToken] = useState("");

  const [turnSrvrUserName, setTurnSrvrUserName] = useState("");
  const [turnSrvrPassword, setTurnSrvrPassword] = useState("");
  const [selectedServer, setSelectedServer] = useState("Stun");
  const [showUserInput, setShowUserInput] = useState(false);
  const [showServerInput, setShowServerInput] = useState(false);
  const [streamMediaSrvrConf, setStreamMediaSrvrConf] = useState({
    Host: "mavricstream.wohler.com", Port: 5443,
    Stun_Server: "",
    Turn_Server: null, Password: null, Username: null,
    WS_AudioStream_Endpoint: "/WebRTCAppEE/websocket"
  });
  const [hasStreamServer, setHasStreamServer] = useState(false);
  const [streamSrvrEndPoint, setStreamSrvrEndPoint] = useState("/WebRTCAppEE/websocket");
  const [gettingStreamSrvrInfo, setGettingStreamSrvrInfo] = useState(false);

  //Error Handling for page
  const [PageHandleMsgError, setPageAlertMsg] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [pageAlertType, setPageAlertType] = useState("error");

  //Add tab state
  const [currentTab, setCurrentTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  function removeCookie(cookieName) {
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  }

  const getStreamServerInfo = () => {

    setGettingStreamSrvrInfo(true);
    getMavricTokenTemplate().then(response => {
      // console.log("stream server info :", response);
      let streamServerInfo = streamMediaSrvrConf;
      let mavricStream = getKeyValue(response, "StreamingServerSettings", null);
      // console.log("\n=== STREAMING SERVER DATA ===");
      // console.log("Raw StreamingServerSettings:", mavricStream);

      let mavricAPIHost = getKeyValue(response, "MavricAPIHost", null);
      let mavricAPITimeout = getKeyValue(response, "MavricAPITimeout", 120);

      let streamHost = getKeyValue(mavricStream, "Host", null);
      let streamPort = getKeyValue(mavricStream, "Port", null);
      let stunServer = getKeyValue(mavricStream, "Stun_Server", null);
      let streamToken = getKeyValue(mavricStream, "StreamToken", null);
      if (streamToken) setStreamSrvrToken(streamToken);
      // else setStreamSrvrToken("");
      let turnServer = getKeyValue(mavricStream, "Turn_Server", null);
      let turnUserName = getKeyValue(mavricStream, "Username", null);
      let turnPassword = getKeyValue(mavricStream, "Password", null);

      if (mavricAPIHost) setMavricAPIHost(mavricAPIHost);
      if (mavricAPITimeout) setMavricAPITimeout(mavricAPITimeout);

      // 3. Handle Message Queue Settings
      let mqSettings = getKeyValue(response, "MessageQueueSettings", null);
      // console.log("\n=== MESSAGE QUEUE SETTINGS ===");
      // console.log("Raw MessageQueueSettings:", mqSettings);
      setMQHost(mqSettings.Host || "");
      setMQPort(mqSettings.Port || "");
      setMQUser(mqSettings.User || "");
      setMQPassword(mqSettings.Password || "");
      setMQTimeout(mqSettings.Timeout || 60);

      // let wsAudioStreamEndpoint = getKeyValue(mavricStream, "WS_AudioStream_Endpoint", null);
      // if (streamHost && streamPort && wsAudioStreamEndpoint)
      if (streamHost && streamPort) {
        setStreamSrvrHost(streamHost);
        setStreamSrvrPort(streamPort);
        // setStreamSrvrEndPoint(wsAudioStreamEndpoint);

        setTurnSrvrUserName(turnUserName ? turnUserName : "");
        setTurnSrvrPassword(turnPassword ? turnPassword : "")

        if (turnServer) setSignalingServer(turnServer);
        else setSignalingServer(stunServer ? stunServer : "");
        streamServerInfo.Host = streamHost;
        streamServerInfo.Port = streamPort;
        // streamServerInfo.WS_AudioStream_Endpoint = wsAudioStreamEndpoint;
        streamServerInfo.Stun_Server = stunServer;
        streamServerInfo.Turn_Server = turnServer;
        streamServerInfo.Username = turnUserName;
        streamServerInfo.Password = turnPassword;
        streamServerInfo.StreamToken = streamToken ? streamToken : "";
        setStreamMediaSrvrConf(streamServerInfo);
        setHasStreamServer(true);
        if (turnServer) {
          setSelectedServer("Turn");
          setShowServerInput(true);
          setShowUserInput(true);
        } else if (stunServer) {
          setSelectedServer("Stun");
          setShowServerInput(true);
          setShowUserInput(false);
        } else {
          setSelectedServer("None");
          setShowServerInput(false);
          setShowUserInput(false);
        }

      } else setHasStreamServer(false);
      setGettingStreamSrvrInfo(false);

    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401 || error.response.status === 403) {
          // <Redirect from="/" to="/login" />
          removeCookie("token");
          let jsonPostMsg = { "user_id": UserId, "token": Token };
          dispatch(logout(jsonPostMsg));
          history.push('/login');
        }
      }
    });
  }

  useEffect(() => {
    getStreamServerInfo();
  }, []);


  const checkValidity = () => {
  if (!validateName(mavricAPIHost) || mavricAPIHost.trim() === '') {
    return "Mavric API Host cannot be empty";
  }
  const apiTimeout = String(mavricAPITimeout);
  if (!mavricAPITimeout || apiTimeout.trim() === '' || isNaN(Number(apiTimeout))) {
    return "Mavric API Timeout must be a valid number";
  }

  if (!mqHost || mqHost.trim() === '') {
    return "Message Queue Host cannot be empty";
  }
  const mqSvrPort = String(mqPort);
  if (!validatePortNumber(mqPort)|| mqSvrPort.trim() === '' || isNaN(Number(mqSvrPort))) {
    return "Message Queue Port must be a valid number";
  }

  if (!mqUser || mqUser.trim() === '') {
    return "Message Queue User cannot be empty";
  }

  if (!mqPassword || mqPassword.trim() === '') {
    return "Message Queue Password cannot be empty";
  }

  const mqSvrTimeout = String(mqTimeout);
  if (!mqTimeout || mqSvrTimeout.trim() === '' || isNaN(Number(mqTimeout))) {
    return "Message Queue Timeout must be a valid number";
  }

  if (!validateName(streamSrvrHost) || streamSrvrHost.trim() === '') {
    return "Streaming Server Host cannot be empty";
  }

  const portStr = String(streamSrvrPort);
  if ( !validatePortNumber(streamSrvrPort) || portStr.trim() === '' || isNaN(Number(portStr))) {
    return "Streaming Server Port must be a valid number";
  }

  if (selectedServer === "Stun") {
    if (!validateName(signalingServer) || signalingServer.trim() === '') {
      return "STUN Server address cannot be empty";
    }
  } 
  else if (selectedServer === "Turn") {
    if (!validateName(signalingServer) || signalingServer.trim() === '') {
      return "TURN Server address cannot be empty";
    }
    if (!turnSrvrUserName || turnSrvrUserName.trim() === '') {
      return "TURN Username cannot be empty";
    }
    if (!turnSrvrPassword || turnSrvrPassword.trim() === '') {
      return "TURN Password cannot be empty";
    }
  }

  return null; 
};

useEffect(() => {
    const validationError = checkValidity();
    if (validationError) {
      setPageAlertMsg(validationError);
      setPageAlertType("error");
      setShowAlert(true);
    } else {
      setShowAlert(false);
    }
 }, [mavricAPIHost, mavricAPITimeout, mqHost, mqPort, mqUser, mqPassword, mqTimeout, signalingServer, streamSrvrHost, streamSrvrPort, turnSrvrUserName, turnSrvrPassword, selectedServer]);


  const handleSubmit = async (event) => {
    event.preventDefault();

    // Validate before submission
    const validationError = checkValidity();
    if (validationError) {
      setPageAlertMsg(validationError);
      setPageAlertType("error");
      setShowAlert(true);
      return;
    }

    const payload = {
      MavricAPIHost: mavricAPIHost,
      MavricAPITimeout: Number(mavricAPITimeout),
      StreamingServerSettings: {
        Host: streamSrvrHost,
        Port: Number(streamSrvrPort),
        Stun_Server: selectedServer === "Stun" ? signalingServer : null,
        Turn_Server: selectedServer === "Turn" ? signalingServer : null,
        Username: selectedServer === "Turn" ? turnSrvrUserName : null,
        Password: selectedServer === "Turn" ? turnSrvrPassword : null
      },
      MessageQueueSettings: {
        Host: mqHost,
        Port: Number(mqPort),
        User: mqUser,
        Password: mqPassword,
        Timeout: Number(mqTimeout)
      }
    };
    // if (validateName(streamSrvrHost) && validatePortNumber(streamSrvrPort)) {
    try {
      console.log("Submitting complete config:", payload);
      const response = await postMavricTokenTemplate(payload);
      // console.log("Response from postMavricTokenTemplate:", response);
      // setStreamMediaSrvrConf(streamServerInfo);
      setHasStreamServer(true);
      setPageAlertMsg("Settings saved successfully!");
      setPageAlertType("success");
      setShowAlert(true);
      getStreamServerInfo();

    } catch (error) {
      console.error("API Error:", error);
      setPageAlertMsg("Failed to save settings. Please try again.");
      setPageAlertType("error");
      setShowAlert(true);

      if (error.response) {
        if (error.response.status === 401 || error.response.status === 403) {
          // <Redirect from="/" to="/login" />
          removeCookie("token");
          let jsonPostMsg = { "user_id": UserId, "token": Token };
          dispatch(logout(jsonPostMsg));
          history.push('/login');
        }
      }
      return;
    }
    // } else {
    //   setHasStreamServer(false);
    //   console.error("Validation failed - please check your inputs");
    //   setPageAlertType("error");
    //   setShowAlert(true);
    // }

  }

  // const onChangeSelectedServer = (event) => {
  //   setSelectedServer(event.target.value);
  //   if (event.target.value === "Stun") {
  //     setShowServerInput(true);
  //     setShowUserInput(false);
  //   } else if (event.target.value === "Turn") {
  //     setShowServerInput(true);
  //     setShowUserInput(true);
  //   } else {
  //     setShowServerInput(false);
  //     setShowUserInput(false);
  //   }
  // }

  const onChangeSelectedServer = (event) => {
    console.log("event.target.value :", event.target.value);
    setSelectedServer(event.target.value);
    setShowUserInput((event.target.value === 'Turn') ? true : false)
    // setShowServerInput((event.target.value === 'None') ? false : true)

  }

  const history = useHistory();


  return (
    <>

      {(!gettingStreamSrvrInfo) &&
        (
          <Box sx={{ marginBottom: 0, marginTop: 2, }}>
            <Card sx={{
              borderRadius: '10px',
              overflow: 'hidden',
            }}>
              <CardContent>
                {/* <Box
                  component="img"
                  sx={{
                    mb: 2
                  }}
                  alt="Wohler Logo"
                  src={StreamSrvrImg}
                  justifyContent="center"
                /> */}
                {/* <Box sx={{ borderColor: 'primary.focus', padding: 0 }}>
                <Tabs
                  value={currentTab}
                  onChange={handleTabChange}
                  indicatorColor="secondary"
                  textColor="secondary"
                  aria-label="configuration tabs">
                  <Tab label="Mavric API" id="config-tab-0" aria-controls="config-tabpanel-0" />
                  <Tab label="Streaming Settings" id="config-tab-1" aria-controls="config-tabpanel-1" />
                  <Tab label="Message Queue" id="config-tab-2" aria-controls="config-tabpanel-2" />
                </Tabs>
                <Divider sx={{ borderColor: primary.divider, mb: 2 }} />
              </Box> */}

                <form onSubmit={handleSubmit}>
                  {/* <Grid container direction="column" justifyContent="center" alignItems="center" spacing={1} > */}
                  {/* <Grid container alignItems="flex-end"> */}
                  {/* <TabPanel value={currentTab} index={0}> */}
                  {/* <Grid item xs={12} sm={4} md={4} lg={6}> */}
                  <Typography variant="body2" fontSize={size.md} justifyContent="center" color={text.main} sx={{ fontWeight: 600, marginBottom: '8px' }} >
                    Mavric API Settings
                  </Typography>
                  {/* </Grid> */}

                  {/* </Grid> */}

                  <Grid container direction="row" spacing={2} alignItems="flex-end">
                    {/* <Typography variant='h6' color={text.main} sx={{ fontWeight: 400, mt: 2 }}>Mavric API Settings</Typography> */}
                    <Grid item xs={12} sm={4} md={4} lg={3} >
                      <Typography fontSize={size.sm} color={text.main} sx={{ fontWeight: 400 }}>API Host</Typography>
                      <TextField
                        value={mavricAPIHost}
                        onChange={(e) => setMavricAPIHost(e.target.value)}
                        fullWidth
                        inputStyle={{ width: "300px" }}
                        placeholder="https://mavricapi.wohler.com"
                        autoComplete="mavric-api-host"
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={4} lg={3} >
                      <Typography fontSize={size.sm} color={text.main} sx={{ fontWeight: 400 }}>API Timeout (seconds)</Typography>
                      <TextField
                        // sx={{ width: 300 }}
                        fullWidth
                        type="number"
                        value={mavricAPITimeout}
                        onChange={(e) => setMavricAPITimeout(e.target.value)}
                        inputStyle={{ width: "300px" }}
                        placeholder="120"
                        autoComplete="mavric-api-timeout"
                      />
                    </Grid>
                    {/* <Grid item xs={12} sm={4} md={4} lg={4} ></Grid> */}
                    <Grid item xs={12} sm={4} md={4} lg={6} sx={{ display: 'flex', justifyContent: 'flex-end', }}>
                      <Button
                        onClick={handleSubmit}
                        variant="contained"
                        color="secondary"
                        sx={{ borderRadius: "4px", padding: "12px 20px" }}
                      >
                        Save
                      </Button>
                    </Grid>
                  </Grid>
                  {/* </TabPanel> */}

                  <Divider sx={{ borderColor: primary.divider, mb: 2, mt: 2 }} />
                  {/* <TabPanel value={currentTab} index={1}> */}
                  <Typography variant="body2" fontSize={size.md} justifyContent="center" color={text.main} sx={{ fontWeight: 600, marginBottom: '8px' }} >
                    Streaming Server Settings
                  </Typography>
                  <Grid container direction="cloumn" spacing={2} sx={{ paddingLeft: 2, paddingTop: 2 }}>
                    <Grid container direction="row" spacing={2} >
                      {/* <Typography variant='h6' color={text.main} sx={{ fontWeight: 400, mt: 2 }}>Streaming Settings</Typography> */}
                      <Grid item xs={12} sm={4} md={4} lg={3}>
                        <Typography fontSize={size.sm} color={text.main} sx={{ fontWeight: 400 }}>Host Name / IP Address</Typography>
                        <TextField
                          // sx={{ width: 300 }}
                          fullWidth
                          error={!validateName(streamSrvrHost)}
                          required
                          id='streamSrvrHost'
                          name='streamSrvrHost'
                          //label="Host Name / IP Address"
                          placeholder="mavricstream.wohler.com"
                          value={streamSrvrHost}
                          //variant="filled"
                          autoComplete="stream-srvr-host"
                          //className={classes.textField}
                          inputProps={{
                            onChange: (e) => {
                              setShowAlert(false);
                              setStreamSrvrHost(String(e.target.value).trim())
                            },
                          }}
                        />
                      </Grid>

                      <Grid item xs={12} sm={4} md={4} lg={3} >
                        <Typography fontSize={size.sm} color={text.main} sx={{ fontWeight: 400 }}>Port Number</Typography>
                        <TextField
                          // sx={{ width: 300 }}
                          fullWidth
                          error={!validatePortNumber(streamSrvrPort)}
                          required
                          id='streamSrvrPort'
                          name='streamSrvrPort'
                          placeholder="443"
                          value={streamSrvrPort}
                          autoComplete="stream-srvr-port"
                          inputProps={{
                            onChange: (e) => {
                              setShowAlert(false);
                              setStreamSrvrPort(e.target.value)
                            },
                          }}
                        />
                      </Grid>

                      <Grid item xs={12} sm={4} md={4} lg={3} >
                        <Typography fontSize={size.sm} color={text.main} sx={{ fontWeight: 400 }}>Stream Token</Typography>
                        <TextField
                          sx={{
                            // width: 300,
                            '& .Mui-disabled .MuiOutlinedInput-notchedOutline': {
                              border: 'none'
                            }
                          }}
                          fullWidth
                          // error={!validatePortNumber(streamSrvrToken)}
                          required
                          id='StreamToken'
                          name='StreamToken'
                          placeholder="23123443"
                          value={streamSrvrToken}
                          autoComplete="stream-srvr-token"
                          inputProps={{
                            onChange: (e) => {
                              setShowAlert(false);
                              setStreamSrvrToken(e.target.value)
                            },
                            readOnly: true,
                          }}
                          disabled={true}

                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid container direction="cloumn" spacing={2} sx={{ paddingLeft: 2, paddingTop: 2, }} >
                    <Grid container direction={"row"} spacing={2} >
                      <Grid item xs={12} sm={4} md={4} lg={3} sx={{ display: 'flex', justifyContent: 'start', marginTop: 2, }}>
                        <FormControl>
                          <RadioGroup row aria-label="anonymous" name="grpSignalingServer" onChange={onChangeSelectedServer} value={selectedServer} sx={{ paddingLeft: 4 }} >
                            <FormControlLabel value="Stun" control={<Radio color="secondary" sx={{ '& .MuiSvgIcon-root': { color: text.main, }, }} />} label={<Typography variant="button" sx={{ fontSize: size.xs, }} color={text.main}>Stun</Typography>} />
                            <FormControlLabel value="Turn" control={<Radio color="secondary" sx={{ '& .MuiSvgIcon-root': { color: text.main, }, }} />} label={<Typography variant="button" sx={{ fontSize: size.xs, }} color={text.main}>Turn</Typography>} />
                            {/* <FormControlLabel value="None" control={<Radio color="secondary" sx={{ '& .MuiSvgIcon-root': { color: text.main, }, }} />} label={<Typography variant="button" sx={{ fontSize: size.xs, }} color={text.main}>None</Typography>} /> */}
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                      {/* </Grid> */}
                      {/* <Grid container direction={"row"} spacing={2} sx={{paddingLeft:2 , marginTop:1}} > */}
                      {(showServerInput) && (
                        <>
                          <Grid item xs={12} sm={4} md={4} lg={3} >
                            <Typography fontSize={size.sm} color={text.main} sx={{ fontWeight: 400 }}>
                              {`${selectedServer} Server`}
                            </Typography>
                            <TextField
                              // sx={{ width: 300 }}
                              fullWidth
                              error={!validateName(signalingServer)}
                              id='signalingServer'
                              name='signalingServer'
                              placeholder={(selectedServer === "Stun") ? "stun1.l.google.com:19302" : "mavricturn.wohler.com"}
                              value={signalingServer}
                              autoComplete="stream-stun-srvr"
                              inputProps={{
                                onChange: (e) => {
                                  setShowAlert(false);
                                  setSignalingServer(e.target.value)
                                },
                              }}
                            />
                          </Grid>
                          {/* {(selectedServer === "Stun") && (
                          <Grid item xs={12} sm={8} md={8} lg={8}></Grid>
                        )} */}
                        </>
                      )
                      }

                      {(showUserInput) && (
                        <>
                          <Grid item xs={12} sm={4} md={4} lg={3} >
                            <Typography fontSize={size.sm} color={text.main} sx={{ fontWeight: 400 }}>User Name</Typography>
                            <TextField
                              // sx={{ width: 300 }}
                              fullWidth
                              error={!validateName(turnSrvrUserName)}
                              id='turnSrvrUserName'
                              name='turnSrvrUserName'
                              placeholder="User Name"
                              value={turnSrvrUserName}
                              autoComplete="stream-stun-srvr"
                              inputProps={{
                                onChange: (e) => {
                                  setShowAlert(false);
                                  setTurnSrvrUserName(e.target.value)
                                },
                              }}
                            />
                          </Grid>

                          <Grid item xs={12} sm={4} md={4} lg={3} >
                            <Typography fontSize={size.sm} color={text.main} sx={{ fontWeight: 400 }}>Password</Typography>
                            <TextField
                              // sx={{ width: 300 }}
                              fullWidth
                              error={!validateName(turnSrvrPassword)}
                              id='turnSrvrPassword'
                              name='turnSrvrPassword'
                              placeholder="Password"
                              value={turnSrvrPassword}
                              autoComplete="stream-turn-srvr"
                              inputProps={{
                                onChange: (e) => {
                                  setShowAlert(false);
                                  setTurnSrvrPassword(e.target.value)
                                },
                              }}
                            />
                          </Grid>
                        </>
                      )}
                      {/* </Grid> */}
                    </Grid>
                  </Grid>
                  {/* </TabPanel> */}
                  <Divider sx={{ borderColor: primary.divider, mb: 2, mt: 2 }} />
                  {/* <TabPanel value={currentTab} index={2}> */}
                  {/* <Grid container direction="column" spacing={2} > */}
                  <Typography variant="body2" fontSize={size.md} justifyContent="center" color={text.main} sx={{ fontWeight: 600, marginBottom: '8px' }} >
                    Message Queue Settings
                  </Typography>
                  <Grid container direction="row" spacing={2}>
                    {/* <Grid container item spacing={1}> */}
                    {/* Message Queue Section */}
                    {/* <Typography variant='h6' color={text.main} sx={{ fontWeight: 400, mt: 2 }}>Message Queue Section</Typography> */}
                    <Grid item xs={12} sm={4} md={4} lg={3} >
                      <Typography fontSize={size.sm} color={text.main} sx={{ fontWeight: 400 }}>Host</Typography>
                      <TextField
                        // sx={{ width: 300 }}
                        fullWidth
                        id='mqHost'
                        value={mqHost}
                        onChange={(e) => setMQHost(e.target.value)}
                        inputStyle={{ width: "300px" }}
                        placeholder="Host Name or IP Address"
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={4} lg={3} >
                      <Typography fontSize={size.sm} color={text.main} sx={{ fontWeight: 400 }}>Port</Typography>
                      <TextField
                        // sx={{ width: 300 }}
                        fullWidth
                        id='mqPort'
                        value={mqPort}
                        onChange={(e) => setMQPort(e.target.value)}
                        inputStyle={{ width: "300px" }}
                        placeholder="port number"
                      />
                    </Grid>
                    {/* </Grid> */}
                    {/* <Grid container item spacing={1}> */}
                    <Grid item xs={12} sm={4} md={4} lg={3} >
                      <Typography fontSize={size.sm} color={text.main} sx={{ fontWeight: 400 }}>Timeout (seconds)</Typography>
                      <TextField
                        // sx={{ width: 300 }}
                        fullWidth
                        id='mqTimeout'
                        type='number'
                        value={mqTimeout}
                        onChange={(e) => setMQTimeout(e.target.value)}
                        inputStyle={{ width: "300px" }}
                        placeholder="60"
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={4} lg={3} >
                      <Typography fontSize={size.sm} color={text.main} sx={{ fontWeight: 400 }}>User</Typography>
                      <TextField
                        // sx={{ width: 300 }}
                        fullWidth
                        id='mqUser'
                        value={mqUser}
                        onChange={(e) => setMQUser(e.target.value)}
                        inputStyle={{ width: "300px" }}
                        placeholder="User Name"
                      />
                    </Grid>
                    {/* </Grid> */}
                    <Grid item xs={12} sm={4} md={4} lg={3} >
                      <Typography fontSize={size.sm} color={text.main} sx={{ fontWeight: 400 }}>Password</Typography>
                      <TextField
                        // sx={{ width: 300 }}
                        fullWidth
                        id='mqPassword'
                        value={mqPassword}
                        onChange={(e) => setMQPassword(e.target.value)}
                        inputStyle={{ width: "300px" }}
                        placeholder="Password"
                      />
                    </Grid>
                    {/* <Grid item xs={12} sm={4} md={4} lg={4} ></Grid> */}
                  </Grid>
                  {/* </TabPanel> */}

                  {/* <Box display="flex" justifyContent="flex-end" gap={2} mt={2} sx={{ paddingRight: 2, paddingBottom: 2 }}>
                    <Button variant="contained" disabled color="secondary" onClick={handleSubmit} sx={{ borderRadius: "4px", padding: "10px 20px" }}>
                      Save
                    </Button>
                  </Box> */}
                  {/* <Grid item>
                    {(showAlert) && (
                      <Alert variant="filled" severity={pageAlertType} sx={{ py: 0 }}>
                        <Typography fontSize={size.sm} color={text.main} sx={{ fontWeight: 400 }}>{PageHandleMsgError}</Typography>
                      </Alert>
                    )}
                  </Grid> */}

                  <Grid container spacing={1} marginTop={2} justifyContent="flex-end">
                    <Grid item>
                      {(showAlert) && (
                        <Alert variant="filled" severity={pageAlertType} sx={{ py: 0 }}>
                          <Typography fontSize={size.md} color={primary.main} sx={{ fontWeight: 400 }}>{PageHandleMsgError}</Typography>
                        </Alert>
                      )}
                    </Grid>
                    {/* <Grid item sx={{ display: 'flex', justifyContent: "end", }}>
                      <Button onClick={handleSubmit} variant="contained" color="secondary" sx={{ borderRadius: "4px", padding: "10px 20px" }}>
                        Save
                      </Button>
                    </Grid> */}
                  </Grid>

                  {/* </Grid> */}
                </form>
              </CardContent>
            </Card>
          </Box >
        )
      }
    </>
  );
}